import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../../context/AuthContext";
import SliderEnableModal from './SliderEnableModal'; // Importar el modal
import { storage } from "../../firebase/firebase.config";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import Loading from '../loading/Loading';

function CargarSlider() {
  const auth = useAuth();
  const userRole = auth.role || null;

  const [fileDesktop, setFileDesktop] = useState(null);
  const [fileMobile, setFileMobile] = useState(null);
  const [previewDesktop, setPreviewDesktop] = useState(null);
  const [previewMobile, setPreviewMobile] = useState(null);
  const [selectedOption, setSelectedOption] = useState('');
  const [dataDesktop, setDataDesktop] = useState([]);
  const [dataMobile, setDataMobile] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showModal, setShowModal] = useState(false); // Estado para el modal
  const navigate = useNavigate();

  const loadData = () => {
    Promise.all([
      axios.get('https://us-central1-inprojuy-f1173.cloudfunctions.net/app/ultimos-sliders'),
      axios.get('https://us-central1-inprojuy-f1173.cloudfunctions.net/app/ultimos-sliders?mobile=true'),
    ])
      .then(([desktopResponse, mobileResponse]) => {
        setDataDesktop(desktopResponse.data);
        setDataMobile(mobileResponse.data);
      })
      .catch((error) => {
        console.error('Error al obtener los datos:', error);
      });
  };

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (!fileDesktop) {
      setPreviewDesktop(null);
      return;
    }
    const url = URL.createObjectURL(fileDesktop);
    setPreviewDesktop(url);
    return () => {
      URL.revokeObjectURL(url);
    };
  }, [fileDesktop]);

  useEffect(() => {
    if (!fileMobile) {
      setPreviewMobile(null);
      return;
    }
    const url = URL.createObjectURL(fileMobile);
    setPreviewMobile(url);
    return () => {
      URL.revokeObjectURL(url);
    };
  }, [fileMobile]);

  const sliderOrder = {
    resultados: 1,
    ganadores_una_mas: 2,
    tercer_slider: 3,
    cuarto_slider: 4,
    sorteo_una_mas: 5,
    telekino: 6,
    quini6: 7,
    brinco: 8,
    ultimo_slider: 9,
    noveno_slider: 10,
    decimo_slider: 11,
  };

  const sortedSlidersData = dataDesktop.sort((a, b) => {
    const orderA = sliderOrder[a?.Slider] || 9999;
    const orderB = sliderOrder[b?.Slider] || 9999;
    return orderA - orderB;
  });

  const sortedMobileSlidersData = dataMobile.sort((a, b) => {
    const orderA = sliderOrder[a?.Slider] || 9999;
    const orderB = sliderOrder[b?.Slider] || 9999;
    return orderA - orderB;
  });

  const handleDesktopChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFileDesktop(selectedFile);
    }
  };

  const handleMobileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFileMobile(selectedFile);
    }
  };

  const handleOptionChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedOption(selectedValue);
  };

  const handleSubmit = async (e, mobileFlag, fileToUpload) => {
    e.preventDefault();

    if (!fileToUpload || !selectedOption) {
      alert('Por favor, seleccione una imagen y una opción válida.');
      return;
    }

    setIsSubmitting(true);

    try {
      // Subir imagen a Firebase Storage
      const fileName = `sliders/${Date.now()}_${fileToUpload.name}`;
      const storageRef = ref(storage, fileName);
      await uploadBytes(storageRef, fileToUpload);
      const url = await getDownloadURL(storageRef);

      // Construir el payload
      const payload = {
        Slider: selectedOption,
        imagen: url,
        mobile: mobileFlag ? 'true' : 'false'
      };
      console.log('Payload enviado:', payload);

      await axios.post('https://us-central1-inprojuy-f1173.cloudfunctions.net/app/slider', payload);

      loadData();
      alert('Los datos se han cargado correctamente');
      if (mobileFlag) {
        setFileMobile(null);
      } else {
        setFileDesktop(null);
      }
      setSelectedOption('');
    } catch (error) {
      console.error('Error al cargar los datos:', error);
      alert('Error al cargar los datos. Inténtalo de nuevo.');
      if (mobileFlag) {
        setFileMobile(null);
      } else {
        setFileDesktop(null);
      }
      setSelectedOption('');
    }

    setIsSubmitting(false);
  };

  if (userRole !== "admin") {
    return (
      <div className="fondotransparente container">
        <center>
          <h2 className="botonbordeazul text-white px-5 py-3 mb-4">Acceso no autorizado</h2>
          <p>Usted no tiene permiso para acceder a esta página.</p>
        </center>
      </div>
    );
  }

  return (
    <div className='fondotransparente container'>
      {isSubmitting && <Loading />}
      <center>
        <div className='d-flex justify-content-center align-items-center mb-4'>
          <h2 className='botonbordeazul text-white px-5 py-3'>Cargar slider</h2>
          <button className='btn btn-primary ms-3' onClick={() => setShowModal(true)}>
            Configurar Sliders
          </button>
        </div>
      </center>
      <h4>Sliders cargados actualmente:</h4>
      <div className="row g-3">
        <div className="col-lg-6">
          <div className="p-3 border rounded-3 bg-white">
            <div className="h6 mb-2">Versión desktop</div>
            <div className="thumbnails-container">
              {sortedSlidersData.map((item, index) => (
                <div key={index} className="thumbnail">
                  <img src={item.imagen} alt={item.Slider} />
                  <p className="slider-caption">{item.Slider}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="p-3 border rounded-3 bg-white">
            <div className="h6 mb-2">Versión móvil</div>
            <div className="thumbnails-container">
              {sortedMobileSlidersData.map((item, index) => (
                <div key={index} className="thumbnail">
                  <img src={item.imagen} alt={item.Slider} />
                  <p className="slider-caption">{item.Slider}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <form className="contactform row g-3 mt-4">
        <div className="col-12">
          <div className="alert alert-info">
            <div><strong>Guía rápida:</strong> Elegí el slider a reemplazar y subí la imagen correspondiente.</div>
            <div><strong>Desktop:</strong> recomendado 1200 x 500 px (horizontal).</div>
            <div><strong>Móvil:</strong> recomendado 900 x 1200 px (vertical).</div>
          </div>
        </div>

        <div className="col-12">
          <div className="row g-3">
            <div className="col-lg-6">
              <div className="p-3 border rounded-3 bg-white">
                <label className="h6 form-label">1) Seleccionar slider *</label>
                <select className="form-select" name="tipo" value={selectedOption} onChange={handleOptionChange} required>
                  <option value="">Seleccione una opción</option>
                  <option value="resultados">Resultados</option>
                  <option value="ganadores_una_mas">Ganadores una mas</option>
                  <option value="tercer_slider">Tercer Slider</option>
                  <option value="cuarto_slider">Cuarto Slider</option>
                  <option value="sorteo_una_mas">Sorteo una mas</option>
                  <option value="telekino">Telekino</option>
                  <option value="quini6">Quini 6</option>
                  <option value="brinco">Brinco</option>
                  <option value="ultimo_slider">Ultimo Slider</option>
                  <option value="noveno_slider">Noveno Slider</option>
                  <option value="decimo_slider">Decimo Slider</option>
                </select>

                <button
                  className='btn btn-outline-primary mt-3'
                  onClick={(e) => { e.preventDefault(); setShowModal(true); }}
                >
                  Configurar Sliders
                </button>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="p-3 border rounded-3 bg-white">
                <div className="h6 mb-2">Paso 2: cargar imágenes</div>
                <div className="row g-3">
                  <div className="col-12">
                    <label className="form-label">Versión desktop</label>
                    <input type='file' accept="image/jpeg, image/png" className="form-control" onChange={handleDesktopChange} />
                    {previewDesktop && (
                      <img
                        src={previewDesktop}
                        alt="Previsualización desktop"
                        style={{
                          width: '100%',
                          marginTop: 8,
                          borderRadius: 8,
                          border: '1px solid #e0e0e0',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                        }}
                      />
                    )}
                    <button
                      className='btn btn-success mt-2'
                      disabled={isSubmitting}
                      onClick={(e) => handleSubmit(e, false, fileDesktop)}
                    >
                      {isSubmitting ? 'Cargando...' : 'Cargar desktop'}
                    </button>
                  </div>
                  <div className="col-12">
                    <label className="form-label">Versión móvil</label>
                    <input type='file' accept="image/jpeg, image/png" className="form-control" onChange={handleMobileChange} />
                    {previewMobile && (
                      <img
                        src={previewMobile}
                        alt="Previsualización móvil"
                        style={{
                          width: '100%',
                          marginTop: 8,
                          borderRadius: 8,
                          border: '1px solid #e0e0e0',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                        }}
                      />
                    )}
                    <button
                      className='btn btn-success mt-2'
                      disabled={isSubmitting}
                      onClick={(e) => handleSubmit(e, true, fileMobile)}
                    >
                      {isSubmitting ? 'Cargando...' : 'Cargar móvil'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 d-flex gap-2">
          <button className='btn btn-outline-danger' disabled={isSubmitting} onClick={() => navigate('/login')}>Volver</button>
        </div>
      </form>
      <SliderEnableModal 
        show={showModal}
        handleClose={() => setShowModal(false)}
        sliderOrder={sliderOrder}
        isSubmitting={isSubmitting}
        setIsSubmitting={setIsSubmitting}
      />
    </div>
  );
}

export default CargarSlider;
